import React, { useEffect, useState } from "react";
import { Table, TableCell, TableRow, IconButton, Grid, TextField, CircularProgress, LinearProgress, Typography } from "@deere/fuel-react";
import { ReactComponent as FileUploadIcon } from "@deere/ux.brand-foundations/icons/upload.svg";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import { uploadSurveyLevelAttachmentWithProgress } from "../../services/surveyHelpDoc.service";
import { getSurveyLevelAttachments, deleteSurveyLevelAttachments } from "../../services/surveypart.service";
import { ERR_DUPLICATE_FILE, ERR_UNSUPPORTED_FILE_SURVEY_PART_UPLOAD } from "../../utils/errorLiterals";
import { FILE_EXTENSIONS_TO_INCLUDE_AT_SURVEY_PART, LBL_NO_DOCS } from "../../utils/surveyLiterals";

const SurveyPartAttachment = ({ surveyCode, assignmentId, token, isAuthMethodOkta, onCountChange, readOnly }) => {
  const [error, setError] = useState({ isError: false, message: "" });
  const [attachments, setAttachments] = useState([]);
  const [loading, setloading] = useState(true);
  const [reloadRequired, setReloadRequired] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    if (onCountChange) {
      onCountChange(attachments.length);
    }
  }, [attachments, onCountChange]);

  useEffect(() => {
    if (!assignmentId || !token || !reloadRequired) return;
    setloading(true);
    getSurveyLevelAttachments(assignmentId, token, isAuthMethodOkta)
      .then((res) => {
        const list = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : []);
        setAttachments(list);
        setloading(false);
        setReloadRequired(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        setReloadRequired(false);
      });
  }, [assignmentId, surveyCode, reloadRequired, token, isAuthMethodOkta]);

  const fileUploadHandler = (event) => {
    event.preventDefault();
    if (readOnly) {
      event.target.value = null;
      return;
    }
    const file = event.target.files?.[0];
    if (!file) return;
    const fileName = file.name;
    const extension = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
    if (!FILE_EXTENSIONS_TO_INCLUDE_AT_SURVEY_PART.includes(extension)) {
      setError({ isError: true, message: (ERR_UNSUPPORTED_FILE_SURVEY_PART_UPLOAD + FILE_EXTENSIONS_TO_INCLUDE_AT_SURVEY_PART) });
      event.target.value = null;
    } else if (attachments.some((a) => a.fileName === fileName)) {
      setError({ isError: true, message: ERR_DUPLICATE_FILE });
      event.target.value = null;
    } else {
      setError({ isError: false, message: "" });
      setUploading(true);
      setUploadProgress(0);
      uploadSurveyLevelAttachmentWithProgress(event.target.files, surveyCode, assignmentId, token, isAuthMethodOkta, (percent) => setUploadProgress(percent))
        .then(() => {
          setUploading(false);
          setReloadRequired(true);
          event.target.value = null;
        })
        .catch((err) => {
          console.log(err);
          setUploading(false);
          event.target.value = null;
        });
    }
  };

  const fileDeleteHandler = (attachmentId) => {
    if (readOnly) return;
    deleteSurveyLevelAttachments(assignmentId, [attachmentId], token, isAuthMethodOkta)
      .then(() => {
        setReloadRequired(true);
      })
      .catch((err) => {
        console.log(err);
        setReloadRequired(true);
      });
  };
  return (
    <>
      <Grid container justifyContent="center" border="2px solid #cccccc" borderRadius="4px">
        {loading ? (
          <Grid item p={2}>
            <CircularProgress value={25} />
          </Grid>
        ) : (
          <Grid item xs={4} mt={2}>
            <Table size="small">
              {attachments && attachments.length > 0 ? (
                attachments.map((attachment) => {
                  return (
                    <TableRow key={attachment.id} sx={{ borderBottom: "1px solid #cccccc!important" }}>
                      <TableCell sx={{ padding: "0" }}>
                        {attachment.fileName}
                      </TableCell>
                      <TableCell sx={{ padding: "0", width: "25px" }}>
                        <IconButton aria-label="Delete" onClick={() => fileDeleteHandler(attachment.id)} disabled={readOnly}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell sx={{ padding: "0", textAlign: "center" }}>{LBL_NO_DOCS}</TableCell>
                </TableRow>
              )}
            </Table>
          </Grid>
        )}

        <Grid item p={5} textAlign="center" width="100%">
          <FileUploadIcon height="36" width="36" fill="#454545" style={{ marginBottom: "10px" }} />
          <TextField
            type="file"
            sx={{ "& .MuiInputBase-input": { height: "auto" } }}
            onChange={fileUploadHandler}
            disabled={readOnly}
            error={error.isError}
            helperText={error.isError && error.message ? error.message : ""}
          />
          <Typography variant="subtitle2" style={{ marginTop: "5px" }}>
            Supported file types: {FILE_EXTENSIONS_TO_INCLUDE_AT_SURVEY_PART.map((ext) => `.${ext}`).join(", ")}  
          </Typography>
          {uploading && (
            <Grid item width="100%" mt={2}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="subtitle2">{uploadProgress}%</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SurveyPartAttachment;
